import createActionType from "../../utils/createActionType";

export const MODULE = "delivery-scheduling/required-date-filter";

export const SET_REQUIRED_START_DATE = createActionType(MODULE, "setRequiredStartDate");
export const SET_REQUIRED_END_DATE = createActionType(MODULE, "setRequiredEndDate");

export const RESET = createActionType(MODULE, "reset");
